<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>父节点</div>
          <div class="es-op-box">
            <el-input placeholder="请输入父节点名称"
                      v-model="queryObj.qfathername"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="
                () => {
                  this.queryObj.pageNum = 1
                  loadfatherdictList()
                }
              ">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right:6px"
                       @click="fatherAdd">新增</el-button>
          </div>
          <el-table :data="fatherPageData.list"
                    ref="dictfatherTable"
                    @current-change="handleCurrentChange"
                    border
                    highlight-current-row
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loadingfather">
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="name"
                             label="字段名称">
            </el-table-column>
            <el-table-column label="操作"
                             width="120"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="编辑"
                         @click="editFatherinit(scope.row)"
                         type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="fatherDel(scope.row.id)"
                           :key="scope.row.id"
                           type="icon"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="fatherPageData"
                           @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadfatherdictList()}">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>子节点[{{queryObj.selectFatherName}}]</div>
          <div class="es-op-box">
            <el-input placeholder="请输入子节点名称"
                      v-model="queryObj.qsonname"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="
                () => {
                  this.queryObj.pageNum = 1
                  loadsondictList()
                }
              ">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right:6px"
                       @click="sonAdd">新增</el-button>
          </div>
          <el-table :data="sonPageData"
                    ref="dictsonTable"
                    border
                    stripe
                    size="mini"
                    highlight-current-row
                    height="calc(100vh - 250px)"
                    v-loading="loadingson">
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="name"
                             width="100"
                             label="名称">
            </el-table-column>
            <el-table-column prop="value"
                             label="值">
            </el-table-column>

            <el-table-column label="操作"
                             width="120"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="编辑"
                         @click="editSoninit(scope.row)"
                         type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="sonDel(scope.row.id)"
                           :key="scope.row.id"
                           type="icon"></es-delete>
              </template>
            </el-table-column>
          </el-table>

        </el-card>
      </el-col>

    </el-row>

    <!--编辑父节点信息-->
    <el-dialog :visible.sync="editfatherVisible"
               @closed="()=>this.$refs['dictFatherForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑父节点
      </span>
      <el-form :model="dictFatherInfo"
               :rules="editFatherRules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="dictFatherForm">
        <el-form-item prop="name"
                      label="名称">
          <el-input v-model="dictFatherInfo.name"
                    placeholder="请输入名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editfatherVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitFatherdict()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>

    <!--编辑子节点信息-->
    <el-dialog :visible.sync="editsonVisible"
               @closed="()=>this.$refs['dictSonForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑子节点
      </span>
      <el-form :model="dictSonInfo"
               :rules="editSonRules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="dictSonForm">
       <el-form-item  label="父节点名称">
                <span>{{queryObj.selectFatherName}}</span>  
        </el-form-item>
        <el-form-item prop="name"
                      label="名称">
          <el-input v-model="dictSonInfo.name"
                    placeholder="请输入名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="value"
                      label="值">
          <el-input v-model="dictSonInfo.value"
                    placeholder="请输入值"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editsonVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitSondict()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'dict',
  props: ["funcs"],
  data () {
    return {
      dictfathers: [],
      queryObj: { pageNum: 1, pageSize: 20, qfathername: "", qsonname: "", selectFatherID: "", selectFatherName: "" },//查询条件      
      fatherPageData: {},
      sonPageData: [],
      editfatherVisible: false,
      editsonVisible: false,
      dictFatherInfo: {},//父节点信息
      dictSonInfo: {},//子节点信息

      editFatherRules: {//父节点验证条件
        name: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ],
      },
      editSonRules: {//子节点验证条件
        name: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }

        ],
        value: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { max: 10, message: '不能超过10个字符', trigger: 'blur' }

        ],
      },

      loadingfather: false,
      loadingson: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadfatherdictList()
    },

    //从后台查询指定字典父节点字段列表
    loadfatherdictList () {
      this.loadingfather = true
      this.$ajax.get('/base/dic/fathrerlist', this.queryObj).then(msg => {
        this.fatherPageData = msg
        this.queryObj.selectFatherID = -1
        this.queryObj.selectFatherName = "无"
        if (this.fatherPageData != null) {
          if (this.fatherPageData.list != null && this.fatherPageData.list.length > 0) {

            this.queryObj.selectFatherID = this.fatherPageData.list[0].id
            this.queryObj.selectFatherName = this.fatherPageData.list[0].name
          }
        }
        this.loadsondictList();

        this.loadingfather = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingfather = false
      })
    },

    //从后台查询指定字典子节点字段列表
    loadsondictList () {
      this.loadingson = true
      this.$ajax.get('/base/dic/sonlist', this.queryObj).then(msg => {
        this.sonPageData = msg
        this.loadingson = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingson = false
      })
    },

    //初始化添加父节点
    fatherAdd () {
      this.editfatherVisible = true
      this.dictFatherInfo = {}

    },
    //初始化编辑父节点
    editFatherinit (row) {

      this.dictFatherInfo = JSON.parse(JSON.stringify(row))
      this.editfatherVisible = true
    },

    //保存父节点信息
    submitFatherdict () {
      this.$refs["dictFatherForm"].validate(valid => {
        if (valid) {
          let dict = JSON.parse(JSON.stringify(this.dictFatherInfo))
          let url = "/base/dic/fatheradd";
          if (dict.id != null) {
            url = "/base/dic/fatheredit";
          }
          this.saving = true
          this.$ajax.post(url, dict).then(msg => {
            this.saving = false
            this.loadfatherdictList()
            this.editfatherVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除父节点信息
    fatherDel (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["dictFatherTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/dic/fatherdelete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadfatherdictList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },

    handleCurrentChange (val) {

      if (val != null) {
        this.queryObj.selectFatherID = val.id
        this.queryObj.selectFatherName = val.name
        this.loadsondictList()
      }
    },


    //初始化添加父节点
    sonAdd () {
      this.editsonVisible = true
      this.dictSonInfo = {}

    },
    //初始化编辑父节点
    editSoninit (row) {

      this.dictSonInfo = JSON.parse(JSON.stringify(row))
      this.editsonVisible = true
    },

    //保存父节点信息
    submitSondict () {
      this.$refs["dictSonForm"].validate(valid => {
        if (valid) {
          this.dictSonInfo.fatherId = this.queryObj.selectFatherID
          let dict = JSON.parse(JSON.stringify(this.dictSonInfo))
          let url = "/base/dic/sonadd";
          if (dict.id != null) {
            url = "/base/dic/sonedit";
          }
          this.saving = true
          this.$ajax.post(url, dict).then(msg => {
            this.saving = false
            this.loadsondictList()
            this.editsonVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除父节点信息
    sonDel (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/dic/sondelete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadsondictList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },






  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
